import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

import shell from './modules/shell';
import properties from './modules/properties';
import searchprofiles from './modules/searchprofiles';
import map from './modules/map';
import auth from './modules/auth';
import langSelector from './modules/langSelector';
import term from './modules/term';
import registrationStep from './modules/registrationStep';
import scheduleFlow from './modules/schedule-flow';
export const strict = false;

export default new Vuex.Store({
  modules: {
    shell,
    properties,
    searchprofiles,
    map,
    auth,
    langSelector,
    term,
    registrationStep,
    scheduleFlow,
  },
  strict: debug,
});
